import type { AreaConversionFunctions } from '@/lib/area/types'

// Square meters to _
/**
 * *(AI-generated)*
 * Converts square meters to acres.
 */
export const sqMetersToAcres = (sqMeters: number) =>
  sqMeters * 0.0002471053814671653
/**
 * *(AI-generated)*
 * Converts square meters to hectares.
 */
export const sqMetersToHectares = (sqMeters: number) => sqMeters * 0.0001
/**
 * *(AI-generated)*
 * Converts square meters to square kilometers.
 */
export const sqMetersToSqKilometers = (sqMeters: number) => sqMeters * 0.000001
/**
 * *(AI-generated)*
 * Converts square meters to square miles.
 */
export const sqMetersToSqMiles = (sqMeters: number) => sqMeters / 2.58999e6

// Acres to _
/**
 * *(AI-generated)*
 * Converts acres to square meters.
 */
export const acresToSqMeters = (acres: number) => acres * 4046.856422
/**
 * *(AI-generated)*
 * Converts acres to hectares.
 */
export const acresToHectares = (acres: number) => acres * 0.404686
/**
 * *(AI-generated)*
 * Converts acres to square kilometers.
 */
export const acresToSqKilometers = (acres: number) => acres / 247.1
/**
 * *(AI-generated)*
 * Converts acres to square miles.
 */
export const acresToSqMiles = (acres: number) => acres / 640

// Hectares to _
/**
 * *(AI-generated)*
 * Converts hectares to square meters.
 */
export const hectaresToSqMeters = (hectares: number) => hectares * 10000
/**
 * *(AI-generated)*
 * Converts hectares to acres.
 */
export const hectaresToAcres = (hectares: number) => hectares * 2.47105
/**
 * *(AI-generated)*
 * Converts hectares to square kilometers.
 */
export const hectaresToSqKilometers = (hectares: number) => hectares * 0.01
/**
 * *(AI-generated)*
 * Converts hectares to square miles.
 */
export const hectaresToSqMiles = (hectares: number) => hectares * 0.003861

// Square kilometers to _
/**
 * *(AI-generated)*
 * Converts square kilometers to square meters.
 */
export const sqKilometersToSqMeters = (sqKilometers: number) =>
  sqKilometers * 1000000
/**
 * *(AI-generated)*
 * Converts square kilometers to acres.
 */
export const sqKilometersToAcres = (sqKilometers: number) =>
  sqKilometers * 247.105
/**
 * *(AI-generated)*
 * Converts square kilometers to hectares.
 */
export const sqKilometersToHectares = (sqKilometers: number) =>
  sqKilometers * 100
/**
 * *(AI-generated)*
 * Converts square kilometers to square miles.
 */
export const sqKilometersToSqMiles = (sqKilometers: number) =>
  sqKilometers * 0.239913

// Square miles to _
/**
 * *(AI-generated)*
 * Converts square miles to square meters.
 */
export const sqMilesToSqMeters = (sqMiles: number) => sqMiles * 2.58999e6
/**
 * *(AI-generated)*
 * Converts square miles to acres.
 */
export const sqMilesToAcres = (sqMiles: number) => sqMiles * 640
/**
 * *(AI-generated)*
 * Converts square miles to hectares.
 */
export const sqMilesToHectares = (sqMiles: number) => sqMiles * 259
/**
 * *(AI-generated)*
 * Converts square miles to square kilometers.
 */
export const sqMilesToSqKilometers = (sqMiles: number) => sqMiles * 2.58999

/**
 * *(AI-generated)*
 * Returns the conversion function for converting from one area unit to another.
 */
export const getConversionFunction = (from: string) => (to: string) => {
  const capitalize = (value: string) =>
    `${value.charAt(0).toUpperCase()}${value.slice(1)}`

  const conversionFunctions: AreaConversionFunctions = {
    sqMetersToAcres,
    sqMetersToHectares,
    sqMetersToSqKilometers,
    sqMetersToSqMiles,
    acresToSqMeters,
    acresToHectares,
    acresToSqKilometers,
    acresToSqMiles,
    hectaresToSqMeters,
    hectaresToAcres,
    hectaresToSqKilometers,
    hectaresToSqMiles,
    sqKilometersToSqMeters,
    sqKilometersToAcres,
    sqKilometersToHectares,
    sqKilometersToSqMiles,
    sqMilesToSqMeters,
    sqMilesToAcres,
    sqMilesToHectares,
    sqMilesToSqKilometers,
  }

  const convert =
    conversionFunctions?.[
      `${from}To${capitalize(to)}` as keyof AreaConversionFunctions
    ]

  if (convert) {
    return convert
  }
  throw new Error(`Conversion from ${from} to ${to} not supported`)
}

/**
 * *(AI-generated)*
 * Returns a number formatter function that formats to the specified maximum fraction digits.
 */
export const formatNumber = (maximumFractionDigits: number) => (num: number) =>
  num.toLocaleString(undefined, {
    maximumFractionDigits,
  })
